module.exports = __webpack_public_path__ + "img/icon-basis-ic-close.3f7ad36d.svg";